<template>
  <div class="audio-container">
    <h2 v-if="title">{{ title }}</h2>

    <div v-if="loading">Lade Audio Datei</div>
    <audio ref="audioplayer" preload="false"
           @canplaythrough="loading=false"
           @timeupdate="timeUpdate()"
    >
      <source ref="audioplayersource" :src="audiourl">
    </audio>
    <div id="audioplayer">
      <button ref="pbutton" class="play pButton" @click="play()" />
      <div ref="timeline" class="timeline" @click="updatetimelineonclick($event)">
        <div ref="playhead" class="playhead" @mousedown="mouseDown()" />
      </div>
      <div ref="showtime" class="showtime">00:00</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Audio',
  props: {
    title: String,
    audiofile: String,
  },
  data() {
    return {
      timelineWidth: null,
      onplayhead: false,
      loading: false,
    }
  },
  computed: {
    audiourl: function () {
      return process.env.VUE_APP_API_ENDPOINT + '/uploads/' + this.audiofile
    },
  },
  watch: {
    audiofile: function () {
      console.log('CHANGE FILE')
    },
  },
  mounted() {
    console.log('MOUNTED')
    this.timelineWidth = this.$refs.timeline.offsetWidth - this.$refs.playhead.offsetWidth
    window.addEventListener('mouseup', this.mouseUp, false)
  },
  beforeUpdate() {
    this.$refs.audioplayer.pause()
    this.$refs.audioplayer.currentTime = 0
  },
  updated() {
    this.$refs.pbutton.className = ''
    this.$refs.pbutton.className = 'play pButton'
    this.$refs.playhead.style.marginLeft = 0
    this.$refs.audioplayer.load()

  },
  methods: {
    getTimeBySeconds(seconds) {
      return new Date(seconds * 1000).toISOString().substr(14, 5)
    },
    clickPercent(event) {
      return (event.clientX - this.getPosition(this.$refs.timeline)) / this.timelineWidth
    },
    mouseDown() {
      this.onplayhead = true
      window.addEventListener('mousemove', this.moveplayhead, true)
      this.$refs.audioplayer.removeEventListener('timeupdate', this.timeUpdate, false)
    },
    mouseUp(event) {
      if (this.onplayhead == true) {
        this.moveplayhead(event)
        window.removeEventListener('mousemove', this.moveplayhead, true)
        // change current time
        this.$refs.audioplayer.currentTime = this.$refs.audioplayer.duration * this.clickPercent(event)
        this.$refs.audioplayer.addEventListener('timeupdate', this.timeUpdate, false)
      }
      this.onplayhead = false
    },
    moveplayhead(event) {
      var newMargLeft = event.clientX - this.getPosition(this.$refs.timeline)

      if (newMargLeft >= 0 && newMargLeft <= this.timelineWidth) {
        this.$refs.playhead.style.marginLeft = newMargLeft + 'px'
      }
      if (newMargLeft < 0) {
        this.$refs.playhead.style.marginLeft = '0px'
      }
      if (newMargLeft > this.timelineWidth) {
        this.$refs.playhead.style.marginLeft = this.timelineWidth + 'px'
      }
    },
    updatetimelineonclick(event) {
      this.moveplayhead(event)
      this.$refs.audioplayer.currentTime = this.$refs.audioplayer.duration * this.clickPercent(event)
    },
    timeUpdate() {
      var playPercent = this.timelineWidth * (this.$refs.audioplayer.currentTime / this.$refs.audioplayer.duration)
      this.$refs.playhead.style.marginLeft = playPercent + 'px'
      if (this.$refs.audioplayer.currentTime == this.$refs.audioplayer.duration) {
        this.$refs.pbutton.className = ''
        this.$refs.pbutton.className = 'play pButton'
      }
      this.$refs.showtime.innerHTML = this.getTimeBySeconds(this.$refs.audioplayer.currentTime)
    },
    play() {
      // start music
      if (this.$refs.audioplayer.paused) {
        this.$refs.audioplayer.play()
        // remove play, add pause
        this.$refs.pbutton.className = ''
        this.$refs.pbutton.className = 'pause pButton'
      } else { // pause music
        this.$refs.audioplayer.pause()
        // remove pause, add play
        this.$refs.pbutton.className = ''
        this.$refs.pbutton.className = 'play pButton'
      }
    },
    getPosition(el) {
      return el.getBoundingClientRect().left
    },
  },
}
</script>



<style scoped lang="scss">
.audio-container {
  padding: 0;
  margin: 0;

  h2 {
    font-weight: 300;
    font-size: 20px;
    text-transform: none;
  }
}
#audioplayer{
  width: 100%;
  height: 60px;
  border: 0;
  box-sizing: border-box;
}

.pButton{
  height:40px;
  width: 40px;
  border: none;
  background-size: 50% 50%;
  background-repeat: no-repeat;
  background-position: center;
  float:left;
  outline:none;
  margin-left: -5px;
  margin-right: 10px;
}

.play{background: url('../assets/play.png') ;background-size: contain}
.pause{background: url('../assets/pause.png') ; background-size: contain}

.timeline{
  width: calc(100% - 45px - 50px);
  height: 20px;
  margin-top: 10px;
  float: left;
  border-radius: 15px;
  background: rgba(0,0,0,.3);

}
.showtime {
  width: 50px;
  float: left;
  margin-top: 10px;
  text-align: right;
}
.playhead{
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-top: 1px;
  background: rgba(0, 0, 0,1);
}
</style>
